export const HANDBOOK_URL =
  "https://docs.google.com/document/d/1GdskVSJhTD3MGJcacp974w8TvvrNlEoP8-k8lHjyQsI/edit?usp=sharing";
